export const CHANGE_LOGIN_STATE = 'header/CHANGE_LOGIN_STATE';














